import React from 'react';
import './UsaTestimonials.css';

const UsaTestimonials = () => {
  const testimonialsData = [
    {
      text: 'My daughter was struggling with basic Arabic letters. After just 4 months with her tutor, she can read the Quran fluently. The one-on-one attention made all the difference — her confidence has completely transformed.',
      name: 'Sarah M.',
      info: 'Texas, USA - Parent',
      duration: '4 months'
    },
    {
      text: 'I started as a complete beginner at age 35. I was worried it would be too late. Ustadh Ahmed was incredibly patient and within 6 months I completed my first Juz with proper Tajweed. Alhamdulillah.',
      name: 'Khalid A.',
      info: 'Houston, Texas · Adult',
      duration: '6 months'
    },
    {
      text: 'Both my sons (ages 7 and 10) take classes here. The female tutor option was very important for my daughter too. Scheduling is flexible and they never missed a class in 8 months. Highly recommend.',
      name: 'Fatima R.',
      info: 'California, USA · Parent',
      duration: '8 months'
    }
  ];

  return (
    <section className="usa-testimonials" id="testimonials">
      <div className="usa-testimonials__container">
        {/* Badge */}
        <div className="usa-testimonials__badge">Real Students, Real Results</div>

        {/* Headings */}
        <h2 className="usa-testimonials__title">Their Stories Speak For Us</h2>
        <p className="usa-testimonials__subtitle">
          Real Students, Real Progress. Every Story Below Is From A Verified Student Of Al Quran Lesson.
        </p>

        {/* Cards Grid */}
        <div className="usa-testimonials__grid">
          {testimonialsData.map((item, index) => (
            <div key={index} className="usa-testimonials__card">
              {/* Quote Icon */}
              <div className="usa-testimonials__quote-icon">
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.19 14.75c0 2.62-2.13 4.75-4.75 4.75s-4.75-2.13-4.75-4.75c0-3.6 3.19-7.16 6.84-8.75l.93 1.83C6.73 9.08 5.75 10.75 5.62 12c1.78.11 3.25 1.5 3.25 3.25 0 .28-.03.56-.09.83.68-.45 1.44-1.07 1.93-1.63l.48.3c.01 0 .01 0 0 0zm11 0c0 2.62-2.13 4.75-4.75 4.75s-4.75-2.13-4.75-4.75c0-3.6 3.19-7.16 6.84-8.75l.93 1.83c-2.73 1.25-3.71 2.92-3.84 4.17 1.78.11 3.25 1.5 3.25 3.25 0 .28-.03.56-.09.83.68-.45 1.44-1.07 1.93-1.63l.48.3c.01 0 .01 0 0 0z" />
                </svg>
              </div>

              {/* Testimonial Text */}
              <p className="usa-testimonials__text">{item.text}</p>

              {/* Divider Line */}
              <div className="usa-testimonials__divider"></div>

              {/* Author Details */}
              <div className="usa-testimonials__author">
                <div className="usa-testimonials__author-meta">
                  <span className="usa-testimonials__author-name">{item.name}</span>
                  <span className="usa-testimonials__author-info">{item.info}</span>
                </div>
                <div className="usa-testimonials__duration-badge">{item.duration}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UsaTestimonials;
